var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.60547C3 6.05318 3.44772 5.60547 4 5.60547H20C20.5523 5.60547 21 6.05318 21 6.60547C21 7.15775 20.5523 7.60547 20 7.60547H4C3.44772 7.60547 3 7.15775 3 6.60547ZM3 12.6055C3 12.0532 3.44772 11.6055 4 11.6055H20C20.5523 11.6055 21 12.0532 21 12.6055C21 13.1578 20.5523 13.6055 20 13.6055H4C3.44772 13.6055 3 13.1578 3 12.6055ZM4 17.6055C3.44772 17.6055 3 18.0532 3 18.6055C3 19.1578 3.44772 19.6055 4 19.6055H20C20.5523 19.6055 21 19.1578 21 18.6055C21 18.0532 20.5523 17.6055 20 17.6055H4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu2.a616acee7c183c0f10411623ff879241.svg";
export { ForwardRef as ReactComponent };